export const OPTIONS_STRATEGY_ORDER = [
  'SHORT_PUT',
  'SHORT_CALL',
  'SHORT_STRADDLE',
  'SHORT_STRANGLE',
  'CALL_SPREAD',
  'PUT_SPREAD',
  'IRON_CONDOR',
  'LONG_CALL',
  'LONG_PUT',
];

export const formatStrategyLabel = (strategy) => {
  if (!strategy) return 'Unknown Strategy';
  return String(strategy)
    .split('_')
    .map((part) => part.charAt(0) + part.slice(1).toLowerCase())
    .join(' ');
};

export const buildStrategyFilterOptions = (strategyValues = []) => {
  const normalized = Array.from(
    new Set(
      (strategyValues || [])
        .filter(Boolean)
        .map((value) => String(value).toUpperCase())
    )
  );

  const ordered = OPTIONS_STRATEGY_ORDER.filter((strategy) => normalized.includes(strategy));
  const remaining = normalized.filter((strategy) => !OPTIONS_STRATEGY_ORDER.includes(strategy)).sort();

  return ['all', ...ordered, ...remaining];
};
